import { types } from 'mobx-state-tree'
import { routes } from '@linqpal/models'
import { createContext, useContext } from 'react'
import _ from 'lodash'
import moment from 'moment'

const InvoicesToPayStore = types
  .model('InvoicesToPayStore', {
    fetchParams: types.maybeNull(types.frozen()),
    items: types.optional(types.array(types.frozen()), []),
    current: types.maybeNull(types.frozen()),
    count: types.optional(types.number, 0),
    selectedToPay: types.optional(types.array(types.frozen()), []),
    selectedInvoices: types.optional(types.array(types.frozen()), []),
    totalInvoiceAmount: types.optional(types.number, 0),
    totalACHDiscount: types.optional(types.number, 0),
  })
  .views((self) => ({
    get invoices() {
      return self.items
        .map((item) => {
          return item
        })
        .flat(1)
    },
    get achDiscountEligibility() {
      const all = self.selectedToPay.every((inv) => !!inv.achDiscount)
      const some = self.selectedToPay.some((inv) => !!inv.achDiscount)
      return { all, some }
    },
  }))
  .actions((self) => ({
    setTotalInvoiceAmount(val: number) {
      self.totalInvoiceAmount = val
    },
    setTotalACHDiscount(val: number) {
      self.totalACHDiscount = val
    },
    setSelectedToPay(data) {
      self.selectedToPay = data
    },
    setSelectedInvoices(selected) {
      self.selectedInvoices = selected
    },
    fetchInvoiceToPay(params?) {
      self.fetchParams = params
      return routes.invoices.payablesInvoices({
        page: -1,
        pageSize: -1,
        dateFrom: moment().subtract(2, 'years').format('MM/DD/YYYY'),
        ...params,
      })
    },
    calculateTotals(invs) {
      const invoices = invs || self.selectedToPay
      const selected = invoices.filter((inv) => inv.selected)
      this.setSelectedInvoices(selected)
      this.setTotalInvoiceAmount(_.sumBy(selected, 'total_amount'))
      this.setTotalACHDiscount(_.sumBy(selected, 'achDiscount'))
    },
    onSelect(invoiceId) {
      const invs = self.selectedToPay.map((i) => {
        if (i._id === invoiceId) return { ...i, selected: !i.selected }
        else return i
      })
      this.calculateTotals(invs)
      this.setSelectedToPay(invs)
    },
    clear() {
      self.fetchParams = null
      self.current = null
      self.count = 0
      self.items.clear()
    },
  }))

export const InvoicesToPayContext = createContext(InvoicesToPayStore.create())
export const InvoicesToPayProvider = InvoicesToPayContext.Provider

export const useInvoicesToPay = () => useContext(InvoicesToPayContext)
